// Navigates by clicking a temporary anchor with referrerPolicy="unsafe-url"
// instead of window.location.assign, which is the only reliable way to send the
// full referrer URL (not just the origin) on cross-origin navigation. Do not
// "simplify" this to window.location.assign — it would strip the path and break
// referrer-dependent flows.
export function navigateWithFullReferrer(url: string): void {
  const a = document.createElement('a')
  a.href = url
  a.referrerPolicy = 'unsafe-url'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
